import { getUin } from 'js/common/helpers';

const HY_LUCKY_DRAW_WHITE_LIST = [
    '1156786985',
    '211968264',
    '481146020',
    '2088250668',
];

export function isInWhiteList() {
    const currentUin = getUin();
    return HY_LUCKY_DRAW_WHITE_LIST.indexOf(currentUin) !== -1;
}
